// Bottom row: top companies (from RSVPs) + top hosts (ambassador ranking).
export const TopPanels = ({ topCompanies, topHosts }) => (
  <div className="mt-14 grid lg:grid-cols-12 gap-8">
    <div className="lg:col-span-7 bg-white border border-[hsl(var(--border))] p-8">
      <div className="overline">Top empresas</div>
      {(topCompanies?.length ?? 0) === 0 ? (
        <p className="mt-4 text-sm text-[hsl(var(--muted-foreground))]">
          Ainda sem empresas registadas nas inscrições.
        </p>
      ) : (
        <ul className="mt-6 grid sm:grid-cols-2 gap-x-12 gap-y-3">
          {topCompanies.map((c) => (
            <li key={c.company} className="flex items-center justify-between border-b border-[hsl(var(--border))] pb-3">
              <span className="text-[hsl(var(--foreground))]">{c.company}</span>
              <span className="text-sm tabular-nums text-[hsl(var(--primary))] font-medium">
                {c.count}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>

    {/* Top hosts — ambassador ranking */}
    <div className="lg:col-span-5 bg-[hsl(var(--primary))] text-white p-8" data-testid="admin-top-hosts">
      <div className="overline text-[hsl(var(--accent))]">Embaixadores {new Date().getFullYear()}</div>
      <p className="mt-2 text-[12px] text-white/70 leading-relaxed">
        Sócios que mais convidados trouxeram este ano.
      </p>
      {topHosts.length === 0 ? (
        <p className="mt-6 text-sm text-white/70">Ainda sem convidados aceites este ano.</p>
      ) : (
        <ol className="mt-6 space-y-3">
          {topHosts.map((h, idx) => (
            <li key={h.host_member_id} className="flex items-center justify-between border-b border-white/10 pb-3 last:border-0">
              <div className="flex items-center gap-3 min-w-0">
                <span className="text-[hsl(var(--accent))] tabular-nums font-medium w-5">{idx + 1}.</span>
                <span className="truncate">{h.host_name || h.host_email}</span>
              </div>
              <span className="text-sm tabular-nums text-[hsl(var(--accent))] font-medium">
                {h.accepted}
              </span>
            </li>
          ))}
        </ol>
      )}
    </div>
  </div>
);

export function StatCard({ icon: Icon, label, value, hint, testid }) {
  return (
    <div className="bg-white border border-[hsl(var(--border))] p-6" data-testid={testid}>
      <div className="flex items-center justify-between">
        <Icon className="h-5 w-5 text-[hsl(var(--accent))]" />
        <div className="overline text-[10px]">{label}</div>
      </div>
      <div className="mt-5 display-heading text-5xl text-[hsl(var(--primary))] tabular-nums">
        {value}
      </div>
      <div className="mt-2 text-xs text-[hsl(var(--muted-foreground))]">{hint}</div>
    </div>
  );
}
